import ContentAccordion from '~/components/content-modules/ContentAccordion.vue';
import ContentAlumniEventList from '~/components/content-modules/alumni/ContentAlumniEventList.vue';
import ContentAlumniLogin from '~/components/content-modules/alumni/ContentAlumniLogin.vue';
import ContentAlumniMemberList from '~/components/content-modules/alumni/ContentAlumniMemberList.vue';
import ContentAlumniPasswordReset from '~/components/content-modules/alumni/ContentAlumniPasswordReset.vue';
import ContentAlumniProfile from '~/components/content-modules/alumni/ContentAlumniProfile.vue';
import ContentAlumniRegister from '~/components/content-modules/alumni/ContentAlumniRegister.vue';
import ContentDepartment from '~/components/content-modules/ContentDepartment.vue';
import ContentDownload from '~/components/content-modules/ContentDownload.vue';
import ContentDownloadOverview from '~/components/content-modules/ContentDownloadOverview.vue';
import ContentImage from '~/components/content-modules/ContentImage.vue';
import ContentImageSlider from '~/components/content-modules/ContentImageSlider.vue';
import ContentImageText from '~/components/content-modules/ContentImageText.vue';
import ContentNews from '~/components/content-modules/ContentNews.vue';
import ContentNewsSlider from '~/components/content-modules/ContentNewsSlider.vue';
import ContentPodcast from '~/components/content-modules/ContentPodcast.vue';
import ContentRegistrationprocess from '~/components/content-modules/ContentRegistrationprocess.vue';
import ContentTeacherDepartment from '~/components/content-modules/ContentTeacherDepartment.vue';
import ContentTeam from '~/components/content-modules/ContentTeam.vue';
import ContentTeammember from '~/components/content-modules/ContentTeammember.vue';
import ContentTeaser from '~/components/content-modules/ContentTeaser.vue';
import ContentTestimonial from '~/components/content-modules/ContentTestimonial.vue';
import ContentText from '~/components/content-modules/ContentText.vue';
import ContentVideo from '~/components/content-modules/ContentVideo.vue';
import CtaContact from '~/components/content-modules/CtaContact.vue';
import CtaDefault from '~/components/content-modules/CtaDefault.vue';
import CtaStoerer from '~/components/content-modules/CtaStoerer.vue';

export const ContentModules = {
  ContentTextRecord: ContentText,
  ContentVideoRecord: ContentVideo,
  ContentRegistrationprocessRecord: ContentRegistrationprocess,
  ContentAccordionRecord: ContentAccordion,
  ContentDownloadRecord: ContentDownload,
  ContentImageRecord: ContentImage,
  ContentImagetextRecord: ContentImageText,
  ContentNewsRecord: ContentNews,
  ContentNewssliderRecord: ContentNewsSlider,
  ContentTeammemberRecord: ContentTeammember,
  ContentTestimonialRecord: ContentTestimonial,
  ContentImagesliderRecord: ContentImageSlider,
  CtaContactRecord: CtaContact,
  ContentTeaserRecord: ContentTeaser,
  CtaStoererRecord: CtaStoerer,
  CtaDefaultRecord: CtaDefault,
  ContentDepartmentRecord: ContentDepartment,
  ContentTeacherDepartmentRecord: ContentTeacherDepartment,
  ContentTeamRecord: ContentTeam,
  ContentDownloadOverviewRecord: ContentDownloadOverview,
  ContentPodcastRecord: ContentPodcast,
  ContentAlumniLoginRecord: ContentAlumniLogin,
  ContentAlumniRegisterRecord: ContentAlumniRegister,
  ContentAlumniPasswordResetRecord: ContentAlumniPasswordReset,
  ContentAlumniProfileRecord: ContentAlumniProfile,
  ContentAlumniMemberListRecord: ContentAlumniMemberList,
  ContentAlumniEventListRecord: ContentAlumniEventList,
};
